import bugsnag from '@bugsnag/js'

let bugsnagClient

if (window.expresoAppState && window.expresoAppState.config.bugsnag.key) {
  bugsnagClient = bugsnag(window.expresoAppState.config.bugsnag.key)

  if (window.expresoAppState.user) {
    bugsnagClient.user = {
      id: window.expresoAppState.user.id,
      name: window.expresoAppState.user.name,
      email: window.expresoAppState.user.email
    }
  }
}

export default bugsnagClient
